import { HarmonyTheme } from '@uhg-harmony/foundations';

export const adaptHarmonyThemeToLegacy = (harmony: HarmonyTheme): Theme => ({
  font: {
    size: {
      body: {
        base: {
          value: 11,
        },
      },
    },
    weight: {
      base: {
        value: 'normal',
      },
    },
    family: {
      base: {
        value: 'OptumSans',
      },
    },
  },
  colors: {
    primary: '#FF612B',
    secondary: '#002667',
    tertiary: '#D9F6FA',
    text: {
      primary: harmony?.HarmonyCoreColorNeutral100 || '#333333',
      secondary: harmony?.HarmonyCoreColorNeutral0 || '#ffffff',
    },
    custom: [
      { name: 'Brand 50', id: 'brand50', value: '#FF612B', type: 'Brand' },
      {
        name: 'Primary 100',
        id: 'primary100',
        value: '#002667',
        type: 'Brand',
      },
      { name: 'Primary 10', id: 'primary10', value: '#D9F6FA', type: 'Brand' },
      { name: 'Primary 5', id: 'primary5', value: '#FBF9F4', type: 'Brand' },
      { id: 'primary20', value: '#B0E3EA', name: 'Primary 20', type: 'Brand' },
      { id: 'primary70', value: '#0C55B8', name: 'Primary 70', type: 'Brand' },
      { id: 'primary90', value: '#003A8D', name: 'Primary 90', type: 'Brand' },
      {
        id: 'primary110',
        value: harmony.HarmonyCoreColorBlue115,
        name: 'Primary 110',
        type: 'Brand',
      },
      {
        id: 'primary120',
        value: harmony.HarmonyCoreColorBlue120,
        name: 'Primary 120',
        type: 'Brand',
      },
      {
        id: 'accent01',
        value: harmony.HarmonyCoreColorPurple5,
        name: 'Accent 01',
        type: 'Brand',
      },
      {
        id: 'accent02',
        value: harmony.HarmonyCoreColorPurple80,
        name: 'Accent 02',
        type: 'Brand',
      },
      { id: 'accent03', value: '#C83402', name: 'Accent 03', type: 'Brand' },
      { id: 'accent04', value: '#912400', name: 'Accent 04', type: 'Brand' },
    ],
    aux: {
      lightestBlue: '#bac0db',
      lightBlue: '#1595fa',
      blue: '#3150bc',
      darkBlue: '#3477db',
      darkNavyBlue: '#002677',
      darkestBlue: '#09228d',
      black: '#000000',
      darkGrey: '#666666',
      lightGrey: '#D1D5D8',
      grey: '#879196',
      offWhite: '#f8f8f8',
      green: '#297a29',
      lightGreen: '#7ed321',
      lighterGreen: '#e0f5e0',
      yellow: '#f29f00',
      lightYellow: '#fff1d6',
      brightYellow: '#f8e81c',
      pink: '#b704d7',
      lightPink: '#fcecfe',
      red: '#e40005',
      lightRed: '#ff787c',
      errorRed: '#c40000',
      blueGrey: '#f2f6f9',
      white: '#ffffff',
      lighterGrey: '#e4e5e7',
      lightestGrey: '#fafafa',
      mutedGrey: '#2B3133',
      skyBlue: '#d9f6fa',
    },
  },
});

export const defaultTheme = adaptHarmonyThemeToLegacy({} as HarmonyTheme);

export type Theme = {
  font: {
    size: {
      body: {
        base: {
          value: number;
        };
      };
    };
    weight: {
      base: {
        value: string;
      };
    };
    family: {
      base: {
        value: string;
      };
    };
  };
  colors: {
    primary: string;
    secondary: string;
    tertiary: string;
    text: {
      primary: string;
      secondary: string;
    };
    custom: Array<{
      name: string;
      id: string;
      value: string;
      type: string;
    }>;
    aux: {
      lightestBlue: string;
      lightBlue: string;
      blue: string;
      darkBlue: string;
      darkNavyBlue: string;
      darkestBlue: string;
      black: string;
      darkGrey: string;
      lightGrey: string;
      grey: string;
      offWhite: string;
      green: string;
      lightGreen: string;
      lighterGreen: string;
      yellow: string;
      lightYellow: string;
      brightYellow: string;
      pink: string;
      lightPink: string;
      red: string;
      lightRed: string;
      errorRed: string;
      blueGrey: string;
      white: string;
      lighterGrey: string;
      lightestGrey: string;
      mutedGrey: string;
      skyBlue: string;
    };
  };
};
